export class ColumnWidth {

  prop = '';
  width = 0;

   constructor(prop: string, width: number) {
    this.prop = prop;
    this.width = width;
   }
 }